import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SeoHead from '../components/SeoHead';
import { useLanguage } from '../hooks/useLanguage';

const ContactConfirmationPage = () => {
  const { t } = useLanguage();

  useEffect(() => {
    document.body.classList.add('header-dark-wrapper');
    const style = document.createElement('style');
    style.innerHTML = `
      .header-dark-wrapper header {
        background-color: #0B1F3F !important;
      }
      .header-dark-wrapper header nav a,
      .header-dark-wrapper header > div > div > div > button {
        color: white !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.body.classList.remove('header-dark-wrapper');
      style.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <SeoHead
        title={`${t('contactConfirmation.title')} | Wownautic`}
        description={t('contactConfirmation.subtitle')}
        canonicalPath="/contact-confirmation"
        noindex
      />
      <Header />

      <main className="flex-1 pt-28 pb-16">
        <div className="max-w-lg mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-green-100 mb-5">
            <CheckCircle2 className="w-11 h-11 text-green-600" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-primary-950 mb-3">
            {t('contactConfirmation.title')}
          </h1>
          <p className="text-lg text-gray-600 mb-8">{t('contactConfirmation.subtitle')}</p>

          <div className="rounded-2xl border border-primary-200 bg-white p-6 mb-8 shadow-sm text-left">
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
                <Mail className="w-5 h-5 text-primary-600" />
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                {t('contactConfirmation.emailNotice')}
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild size="lg" className="bg-primary-600 hover:bg-primary-700">
              <Link to="/">{t('contactConfirmation.backHome')}</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-primary-300">
              <Link to="/contact">{t('contactConfirmation.sendAnother')}</Link>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactConfirmationPage;
